export default {
  getLeagueViewData(state) {
    return state.leaguesData;
  },
  getSelectedTeams(state) {
    return state.selectedTeams;
  },
  getSelectedLeague(state) {
    return state.selectedLeague;
  },
  getPromoConfig(state) {
    return state.promoConfig;
  },
  getPromoContent(state) {
    return state.promoContent;
  },
  getLoadead(state) {
    return state.isLoaded;
  },
  getSelectedLeagueId(state) {
    return state.selectedLeagueId;
  },
  getUserPick(state) {
    return state.userPick;
  },
  getEditState(state) {
    return state.editState;
  },
  getLeagueTable(state) {
    return state.leagueTable;
  },
  getLeagueMatches(state) {
    return state.leagueMatches;
  },
  getFocusedCharacter(state) {
    return state.focusedCharacter;
  },
  getPromoStatus(state) {
    return state.promoStatus;
  },
  getApiData(state) {
    return state.apiData;
  }
};
